module.exports = __webpack_public_path__ + "static/img/USC_Marshall_CurriculumMap_2023_BUAD_R5.f2ca460.png";


//////////////////
// WEBPACK FOOTER
// ./static/USC_Marshall_CurriculumMap_2023_BUAD_R5.png
// module id = 298c
// module chunks = 1